const strings = {
  textModal: {
    ModalTitle: 'Cadastro de cultivar',
  },
}

export default strings
